import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {createStore, applyMiddleware, combineReducers, compose} from "redux";
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import {Provider} from 'react-redux';
import thunk from "redux-thunk";
import {BrowserRouter} from "react-router-dom";
import axios from "axios";
import * as Configs from './config';

import authenticationReducer from './store/reducer/authentication';
import loggedInUserInfoReducer from './store/reducer/loggedInUserInfo';
import contextReducer from './store/reducer/contextReducer';
import widgetReducer from './store/reducer/widgetReducer';

axios.defaults.baseURL = Configs.BaseURL;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    auth: authenticationReducer,
    user: loggedInUserInfoReducer,
    context: contextReducer,
    widget: widgetReducer

});

const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunk)
));
const app = (
    <Provider store={store}>
        <BrowserRouter basename={Configs.WebURLPrefix}>
            <App/>
        </BrowserRouter>
    </Provider>
)

ReactDOM.render(app, document.getElementById('yotascale'));

serviceWorker.unregister();
